module.exports = "https://cdn-web.ertelecom.ru/b2c-domru/frontend/_next/static/images/main-big-d7c5531e0b6c147030ef508fe38df274.svg";